export const TYPE_FRIENDLY_NAME_POLICIES_MAP: Record<string, string> = {
  restriction: 'Restriction',
  requirement: 'Requirement',
  guideline: 'Guideline',
  warning: 'Warning',
};

export const POLICY_TYPE_OPTIONS = Object.keys(TYPE_FRIENDLY_NAME_POLICIES_MAP);

/** Call-flow order: the grouping, the filter menu and its counts all read this. */
export const POLICY_CATEGORIES = [
  'Triage',
  'Troubleshooting',
  'Membership',
  'Escalation',
  'Transfer & Sales',
  'General',
] as const;

export const POLICY_CATEGORY_ESCALATION = 'Escalation';

/** Categories available in the standard "Add Policy" form (excludes Escalation). */
export const POLICY_CATEGORIES_STANDARD = POLICY_CATEGORIES.filter(
  (c) => c !== POLICY_CATEGORY_ESCALATION,
);
